;(function() {
  'use strict'

  Controller.$inject = ["mediaView"];
  angular.module('app.survey').component('surveyQuestionConstantSum', {
    controller: Controller,
    templateUrl: 'survey-question-constant-sum.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller(mediaView) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onChange = onChange
    ctrl.onBlur = onBlur
    ctrl.expandImage = expandImage

    function onInit() {
      ctrl.question.injectConstantSumPipesValue()
      ctrl.choices = ctrl.question.getVisibleChoices()
      ctrl.numbers = {} // entered numbers model
      _.each(ctrl.choices, function(choice) {
        ctrl.numbers[choice.id] = ctrl.question.getSelectedNumber(choice)
      })
      ctrl.prefix = ctrl.survey.injectValues(
        ctrl.question.textPrefixPipes,
        ctrl.question.loopKey
      )
      ctrl.suffix = ctrl.survey.injectValues(
        ctrl.question.textSuffixPipes,
        ctrl.question.loopKey
      )
    }

    function onChange(choice) {
      ctrl.question.setSelectedNumber(ctrl.numbers[choice.id], choice)
    }

    function onBlur(choice) {
      var number = ctrl.numbers[choice.id]
      if (!_.isNumber(number)) return // skip
      ctrl.numbers[choice.id] = ctrl.question.clampNumber(number)
      onChange(choice)
    }

    function expandImage(event, imageUrl) {
      event.preventDefault()
      event.stopPropagation()
      mediaView.showImage(imageUrl)
    }
  }
})()
